/** Pill segmented control (DESIGN → Components). Each option is a ≥ 44 px tab. */
export function SegmentedControl<T extends string>({
	label,
	options,
	value,
	onChange,
}: {
	label: string;
	/** `accent`: something new waits there, the tab pulses softly (T-1335). */
	options: readonly { value: T; label: string; accent?: boolean }[];
	value: T;
	onChange: (value: T) => void;
}) {
	return (
		<div role="tablist" aria-label={label} className="bg-surface flex rounded-full p-1">
			{options.map((option) => (
				<button
					key={option.value}
					type="button"
					role="tab"
					aria-selected={option.value === value}
					onClick={() => {
						onChange(option.value);
					}}
					className={`text-body min-h-11 flex-1 rounded-full px-3 font-semibold transition-colors duration-150 ${
						option.value === value
							? 'bg-primary text-text'
							: option.accent === true
								? 'text-primary animate-soft-pulse motion-reduce:animate-none'
								: 'text-text-muted'
					}`}
				>
					{option.label}
				</button>
			))}
		</div>
	);
}
